import React, { useState } from 'react';
import BookingList from '@/components/booking/BookingList';
import ShipmentList from '@/components/shipment/ShipmentList';
import BookingForm from '@/components/booking/BookingForm';
import BookingPrint from '@/components/booking/BookingPrint';

const Booking = () => {
    const [view, setView] = useState('list'); // list | form | print
    const [selectedShipment, setSelectedShipment] = useState(null);

    const handleCreateNew = () => {
        setSelectedShipment(null);
        setView('form');
    };

    const openBookingInNewTab = (shipmentOrId) => {
        const id =
            typeof shipmentOrId === "object"
                ? shipmentOrId?.id ?? shipmentOrId?.BookingId
                : shipmentOrId;
        if (!id) return;
        window.open(
            `${window.location.origin}/booking/edit/${id}`,
            "_blank",
            "noopener,noreferrer",
        );
    };

    const handleViewShipment = (shipmentOrId) => {
        openBookingInNewTab(shipmentOrId);
    };

    const handlePrintShipment = (shipment) => {
        setSelectedShipment(shipment);
        setView('print');
    };

    const handleBackToList = () => {
        setSelectedShipment(null);
        setView('list');
    };

    const handleBackToForm = () => {
        setView('list');
    };

    return (
        <div className="h-full p-3 sm:p-4 lg:p-6">
            {view === 'list' && (
                <ShipmentList
                    onCreateNew={handleCreateNew}
                    onViewShipment={handleViewShipment}
                    onPrintShipment={handlePrintShipment}
                />
            )}

            {view === 'form' && (
                <BookingForm
                    bookingData={selectedShipment}
                    onBack={handleBackToList}
                    onPrint={handlePrintShipment}
                />
            )}

            {view === 'print' && (
                <BookingPrint
                    bookingData={selectedShipment}
                    onBack={handleBackToForm}
                />
            )}
        </div>
    );
};

export default Booking;
